export const LgSizes14IconSmall= () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7.33641" y="3.75587" width="16.6967" height="12.1446" stroke="#909090" strokeWidth="1.51169"/>
            <rect x="7.33641" y="15.7983" width="16.6967" height="12.1446" stroke="#909090" strokeWidth="1.51169"/>
        </svg>
    )
}
export const LgSizes14IconSmall= () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7.33641" y="3.75587" width="16.6967" height="12.1446" stroke="#909090" strokeWidth="1.51169"/>
            <rect x="7.33641" y="15.7983" width="16.6967" height="12.1446" stroke="#909090" strokeWidth="1.51169"/>
        </svg>
    )
}
